var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'chartdiv' + _vm.transceiverId + _vm.series,staticClass:"chart",attrs:{"id":'chartdiv' + _vm.transceiverId + _vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }